import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=146e593c"
import script from "./DataTablePagination.vue?vue&type=script&lang=js"
export * from "./DataTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports